<script setup lang="ts">
import { ref } from 'vue';

import { useCurrentSegment } from '@/composables/useCurrentSegment';
import CalculationViewStepper from '../components/CalculationViewStepper.vue';
import CalculationGroupNavigation from '../components/CalculationGroupNavigation.vue';
import CalculationGroupStepper from '../components/CalculationGroupStepper.vue';
import HideInputsButton from '../components/HideInputsButton.vue';

const { currentSegmentGroupsViews, currentSegment, navigableSegmentGroups } = useCurrentSegment();

const selectedItems = ref<{ [key: string]: number | null }>({});
</script>

<template>
  <div>
    <CalculationGroupStepper v-if="navigableSegmentGroups.length > 1" class="mb-4" />

    <header class="text-md mb-4 flex justify-between font-bold text-gray-900">
      {{ currentSegmentGroupsViews?.name }}

      <HideInputsButton />
    </header>

    <CalculationViewStepper v-model:selectedItems="selectedItems" />

    <CalculationGroupNavigation
      v-if="!currentSegment?.is_required"
      class="mt-6"
      v-model:selectedItems="selectedItems"
    />
  </div>
</template>
